import {useEffect, useRef, useState} from "react";
import irt  from "../../img/coins/irt.svg";
import Chart from "./profile/chart";

const Index = (props) => {

    const {slug} = props.ctx.useParams();

    const [input , setInput] = useState(0);
    const [output , setOutput] = useState(0);
    const info = useRef({
        frame : '',
        info: {}
    });

    const [mode , setMode] = useState(false)
    const [data , setData] = useState({"s": "no_data", "t": [], "o": [], "h": [], "l": [], "c": [], "v": []})


    function submitReq() {

        if (props.ctx.auth === null) {

            props.ctx._notif('error','لطفا در ابتدا لاگین کنین')
            return ;
        }

        const type = mode=== true? 'sell':'buy';

        props.ctx.ajax(window.config.api + "/profile/trade", {

            authToken: props.ctx.auth,
            type: type,
            amount: input

        }).then(function (res) {
            if(res && res.status){
                props.ctx._notif(res.status,res.message)
            }else{
                props.ctx._notif('error','خطایی رخ داده است لطفا دوباره امتحان کنید')
            }

        })
    }

    function tare() {
        props.ctx.ajax(window.config.api + "/healthcheck/usdt", {}).then(function (res) {
            setData(res)
        })
    }

    props.trs.forEach(function (v) {
        if (v.en === slug) info.info = v;
    })

    useEffect(function () {
        tare()
    }, [])
    if (slug === undefined || slug === '') {
        return '';
    }
    if (info === undefined) return;
    if (info.info === undefined) return;
    if (info.info.name === undefined) return;



    return (

        <div className="row g-10">
            <div className="col-lg-12">
                <div className="card border shadow-none">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover table-nowrap">
                                <thead className="thead-light">
                                <tr>
                                    <th scope="col">قیمت فروش <span className="text-muted text-sm"> (تومان) </span></th>
                                    <th scope="col">قیمت خرید <span className="text-muted text-sm"> (تومان) </span></th>

                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="text-end text-heading" dir="ltr"><span
                                        className="en font-bold"> <span
                                        className="en font-bold"> {parseFloat(info.info.sell).toLocaleString()} </span> </span>
                                    </td>
                                    <td className="text-end text-heading" dir="ltr"><span
                                        className="en font-bold">{parseFloat(info.info.buy).toLocaleString()} </span></td>



                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-8 vstack gap-4">
                <div className="card p-5 border shadow-none">
                    <div className="tradingview-widget-container mb-5">
                        <div id="tradingview_container" style={{height: "600px"}}>
                            <div id="tradingview_2f3fd-wrapper"
                            >
                                <div>
                                    {slug !=='USDT' && info.frame !== '' && <iframe style={{width: '100%', height: '600px'}} id="tradingview_2f3fd"
                                             src={info.frame}

                                             frameBorder="0" allowTransparency="true" scrolling="no" allowFullScreen="">
                                    </iframe>}

                                    {
                                        slug ==='USDT' && <div style={{width: '100%', height: '600px'}}> <Chart ctx={props.ctx} data={data} /></div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="col-lg-4 vstack gap-6">
                <div className="card shadow-none border position-lg-sticky top-lg-5">
                    <div className="card-body">
                        <div className="quick-quote">
                            <div id="frmDemo" name="frmDemo" noValidate="novalidate">
                                <div className="mb-0"><label className="form-label youget mb-0"
                                                             htmlFor="demoFromAmount"> پرداخت میکنم </label>
                                    <div className="input-group position-relative">

                                        <input
                                            value={props.addCommos(input)} onChange={(e)=>{
                                                var amount = parseFloat(props.removeCommos(e.target.value))
                                            if( mode === false){
                                                setOutput((amount /  info.info.sell).toFixed(2))
                                            }else{
                                                setOutput((amount *  info.info.sell).toFixed(2))
                                            }


                                            setInput(amount)

                                        }}
                                        className="form-control text-sm"/>
                                        {mode === true ? <button className="input-group-text px-4" type="button"
                                                                 id="demoToSelectorButton"><img id="demoToImg"
                                                                                                alt={info.info.alt}
                                                                                                src={info.info.logo}
                                                                                                className="avatar avatar-xs rounded-circle ms-2"/>
                                            <span className="text-sm font-semibold text-dark2 d-none d-sm-block"
                                                  id="demoToLocalizedName"> {info.info.name} </span> <i
                                                className="far fa-arrow-left me-3 opacity-30"> </i></button> :<button className="input-group-text px-4" type="button"
                                                 id="demoFromSelectorButton">
                                            <img id="demoFromImg" alt="خرید و فروش بیت کوین"
                                                 src={irt}
                                                 className="avatar avatar-xs rounded-circle ms-2"/>
                                            <span className="text-sm font-semibold text-dark2 d-none d-sm-block"
                                                  id="demoFromLocalizedName"> تومان </span>
                                            <i className="far fa-arrow-left me-3 opacity-70"> </i>
                                        </button>}
                                    </div>
                                </div>
                                <div className="mb-0">
                                    <div className="switch text-end"><label
                                        className="form-label text-muted text-sm mb-0 d-block"> نرخ تبدیل </label>
                                        <span
                                            className="unit-price en font-bold" dir="ltr"
                                            id="demoRate"> {parseFloat(mode === true? info.info.sell : info.info.buy).toLocaleString()} </span>


                                        <button onClick={()=>{
                                            setMode(!mode)
                                            setInput(0)
                                            setOutput(0)
                                        }} type="button"
                                                className="btn btn-neutral btn-sm icon icon-shape rounded-circle text-lg float-start mt--5px"
                                                id="demoActionSwitch"><i className="far fa-repeat opacity-50"> </i>
                                        </button>

                                    </div>
                                </div>
                                <div className="mb-5 mt--5px"><label className="form-label youget mb-0"
                                                                     htmlFor="demoToAmount"> دریافت میکنم </label>
                                    <div className="input-group position-relative">

                                        <input
                                        className="form-control text-sm"  value={props.addCommos(output)}   id="demoToAmount" readOnly={true}/>

                                        {mode === true ? <button className="input-group-text px-4" type="button"
                                                                     id="demoFromSelectorButton">
                                            <img id="demoFromImg" alt="خرید و فروش بیت کوین"
                                                 src={irt}
                                                 className="avatar avatar-xs rounded-circle ms-2"/>
                                            <span className="text-sm font-semibold text-dark2 d-none d-sm-block"
                                                  id="demoFromLocalizedName"> تومان </span>
                                            <i className="far fa-arrow-left me-3 opacity-70"> </i>
                                        </button> :  <button className="input-group-text px-4" type="button"
                                                             id="demoToSelectorButton"><img id="demoToImg"
                                                                                            alt={info.info.alt}
                                                                                            src={info.info.logo}
                                                                                            className="avatar avatar-xs rounded-circle ms-2"/>
                                            <span className="text-sm font-semibold text-dark2 d-none d-sm-block"
                                                  id="demoToLocalizedName"> {info.info.name} </span> <i
                                                className="far fa-arrow-left me-3 opacity-30"> </i></button> }


                                    </div>
                                </div>
                                <div>
                                    <button onClick={submitReq} className="btn btn-success w-full"><i
                                        className="far fa-bags-shopping ms-1 opacity-50"> </i> {mode === true ? 'فروش' : 'خرید'}
                                    </button>
                                </div>
                            </div>
                        </div>


                        <h5 className="mb-3 mt-10">اطلاعات ارز:</h5>
                        <hr className="mb-0 mt-3"/>
                        <div className="list-group list-group-flush mb-4">
                            <div
                                className="list-group-item d-flex justify-content-between align-items-center py-3">
                                <div className="col-auto"><span
                                    className="d-inline-block text-sm font-semibold text-muted"> نام ارز </span>
                                </div>
                                <div className="col-auto">
                                    <div
                                        className="d-inline-block align-middle text-sm block-list text-end font-semibold">
                                        <span> {(info.info.name)} </span></div>
                                </div>
                            </div>
                            <div
                                className="list-group-item d-flex justify-content-between align-items-center py-3">
                                <div className="col-auto"><span
                                    className="d-inline-block text-sm font-semibold text-muted"> نماد اختصاری </span>
                                </div>
                                <div className="col-auto">
                                    <div
                                        className="d-inline-block align-middle text-sm block-list text-end font-bold">
                                        <span className="en"> {(info.info.en)}  </span></div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </div>

        </div>

    )
}
export default Index;
